import React, { useContext, useState, useEffect } from 'react'
import { Input, Box } from '@postenbring/hedwig-react'
import { InternationalCalculatorContext } from '../../InternationalCalculatorContext'
import '../../Calculator.css'

export const DimensionInput = ({ labels }) => {
  const {
    dimensions,
    setDimensions,
    setInputError,
    errorInput,
    serviceType,
    destination
  } = useContext(InternationalCalculatorContext)

  const [localDimensions, setLocalDimensions] = useState(dimensions)

  useEffect(() => {
    setLocalDimensions(dimensions) // Sync from context when dimensions change
  }, [dimensions])

  const dimensionFields = [
    { label: labels.weight, name: 'weight', placeholder: 'Kg' },
    { label: labels.length, name: 'length', placeholder: 'Cm' },
    { label: labels.width, name: 'width', placeholder: 'Cm' },
    { label: labels.height, name: 'height', placeholder: 'Cm' },
  ]

  const handleChange = (name, value) => {
    value = value.replace('.', ',')
    const maxLength = name === 'weight' ? 2 : 3
    const regex = new RegExp(`^[0-9]{0,${maxLength}}(,[0-9]?)?$`)

    if (value === '' || (regex.test(value) && value[0] !== ',')) {
      setLocalDimensions((prev) => ({ ...prev, [name]: value }))
    }
  }

  const handleBlur = (name) => {
    const value = localDimensions[name]
    setDimensions((prev) => ({ ...prev, [name]: value }))

    if (name === 'weight') {
      const weightValue = parseFloat(value.replace(',', '.'))
      if (serviceType === 'PICKUP_PARCEL') {
        if (weightValue < 0.1 || weightValue > 20) {
          setInputError(labels.dimensionNotValidValueText)
        } else {
          setInputError(null)
        }
      } else if (serviceType === 'BUSINESS_PARCEL') {
        const max = ['DK', 'SE', 'FI'].includes(destination) ? 35 : 30
        if (weightValue < 0.1 || weightValue > max) {
          setInputError(labels.dimensionNotValidValueText)
        } else {
          setInputError(null)
        }
      }
    }
  }

  return (
    <div className="dimension-input-stack">
      {dimensionFields.map(({ label, name, placeholder }) => (
        <Input
          key={name}
          className="dimension-input"
          placeholder={placeholder}
          errorMessage={name === 'weight' ? errorInput : null}
          min={1}
          type="text"
          label={label}
          value={localDimensions[name] ?? ''}
          maxLength={4}
          onChange={(e) => handleChange(name, e.target.value)}
          onBlur={() => handleBlur(name)}
          autoComplete="off"
        />
      ))}
    </div>
  )
}